import { TextHeightSVG, Icon } from "@newsela/angelou";
import PropTypes from "prop-types";

import SecondaryActionButton from "@/view/SecondaryActionsToolbar/SecondaryActionButton";
import { iconCss } from "./FontSizeAction.style";
import FontSizeMobileAction from "./FontSizeMobileAction";
import FontSizeOptions from "./FontSizeOptions";
import { sizeOptions } from "./sizeOptions";

const propTypes = {
  activeSubMenu: PropTypes.string,
  contentId: PropTypes.string,
  currentFontSize: PropTypes.string,
  disabled: PropTypes.bool,
  hoverLabel: PropTypes.string,
  isMobile: PropTypes.bool,
  setActiveSubMenu: PropTypes.func,
  setCurrentFontSize: PropTypes.func,
};

const FontSizeAction = ({
  activeSubMenu,
  contentId,
  currentFontSize,
  disabled,
  hoverLabel,
  isMobile,
  setActiveSubMenu,
  setCurrentFontSize,
}) => {
  const eventProperties = {
    actionName: "Interact",
    objectType: "Content",
    streamProperties: {
      content_id: contentId,
      content_type: "Article",
      description: "Show font size options list",
      object_id: contentId,
    },
  };

  const popOutContents = (
    <FontSizeOptions
      contentId={contentId}
      currentFontSize={currentFontSize}
      isMobile={isMobile}
      setCurrentFontSize={setCurrentFontSize}
    />
  );

  const icon = (
    <Icon SvgComponent={TextHeightSVG} __cssFor={{ root: iconCss }} />
  );

  const currentSizeIndicator = sizeOptions[currentFontSize]?.indicator;
  const currentSizeLabel = `Size: ${currentSizeIndicator}`;
  const dataProps = { "data-qa-selector": "expand-fontsize-menu" };
  const ariaProps = { "aria-label": `Size: ${currentFontSize}` };
  if (isMobile) {
    return (
      <FontSizeMobileAction
        activeSubMenu={activeSubMenu}
        currentSizeLabel={currentSizeLabel}
        dataProps={dataProps}
        disabled={disabled}
        eventProperties={eventProperties}
        icon={icon}
        popOutContents={popOutContents}
        setActiveSubMenu={setActiveSubMenu}
      />
    );
  }
  return (
    <SecondaryActionButton
      ariaProps={ariaProps}
      dataProps={dataProps}
      disabled={disabled}
      eventProperties={eventProperties}
      hoverLabel={hoverLabel}
      icon={icon}
      popOutContents={popOutContents}
      title={currentSizeLabel}
    />
  );
};

FontSizeAction.propTypes = propTypes;
export default FontSizeAction;
